import { useContext } from "react";
import { FiltersContext } from "../contexts/FiltersContext";

export function useFilters() {
    const value = useContext(FiltersContext);
    return value;
}